import { UrlsUtils } from "../utils/UrlsUtils";

export class ContentUtils
{
      static clean_content(content, featuredImage) {
        var content_ok = content.replace("<p","<p class=\"the-content-event\"").replace("<h3","<h4")
        if (featuredImage && featuredImage.mediaItemUrl) {
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" areplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" breplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" creplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" dreplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" ereplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" freplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl,"/img/white_pixel.png\" style=\"display:none\" greplaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl.replace(".png",""),"/img/white_pixel.png\" aastyle=\"display:none\" replaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
          content_ok = content_ok.replace(featuredImage.mediaItemUrl.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
          /*content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
          content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
          content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
          content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
          content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
          content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
          content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");*/
        }
        content_ok = UrlsUtils.ensure_wp_content(content_ok);
        content_ok = UrlsUtils.ensure_wp_admin_url(content_ok);
        return content_ok;
      }

      static hbsptFormsCreate(content_ok) {
        // console.log("hbspt content_ok", content_ok);
        try {
          var region;
          try {
            region = content_ok
            .split('region: "')
            .pop()
            .split('",')[0];
            if (region && region.length !== 3) region = undefined;
          } catch {}
          var portalId = content_ok.split('portalId: "').pop().split('"')[0];
          var formId = content_ok.split('formId: "').pop().split('"')[0];

          if (
            window.hbspt &&
            !isNaN(portalId) &&
            !isNaN(parseFloat(portalId)) &&
            formId
          ) {
            var params = {
              portalId: portalId,
              formId: formId,
            };
            if (region) {
              params["region"] = region;
            }
            // console.log("hbspt params", params);
            // console.log("hbspt created");
            window.hbspt.forms.create(params);
          }
        } catch (error) {
          console.log("hbspt error", error);
        }
      }

      static readTimeFromWordCount(words_count) {
        // var time = 60;
        var words_per_minutes = 300;
        return Math.round((words_count/words_per_minutes))
        // return fmtMSS(Math.round((words_count/words_per_minutes) * time))
      }

      static readingTime(html_element) {
        var words = html_element.textContent.split(' ').filter(item => {return item !== "";})
        var words_count = words.length;
        //var words_count = 640;
        return this.readTimeFromWordCount(words_count);
      }

      //come richiamare funzione su single e singlefor404 ???
      static showTime(contentCleaned)
      {
        let cleanText = contentCleaned.replace(/<\/?[^>]+(>|$)/g, "");
        let words = cleanText.split(' ').filter(item => {return item !== "";})
        let words_count = words.length;
        let time_read = this.readTimeFromWordCount(words_count);
        return time_read;
      }







}
